import React from "react";
import { connect } from "react-redux";
import { Table } from "reactstrap";

const mapStateToProps = (state) => {
    return {
        getTutorDetail: state.TutorReducer.getTutorDetail,
        errorTutorDetail: state.TutorReducer.errorTutorDetail,
    };
};

const TutorDetail = (props) => {
    const isEmpty   = props.getTutorDetail.length === 0;
    const tutor     = Object.values(props.getTutorDetail);
    
    return (
        
        <Table striped>
            <tbody>


                {isEmpty ?
                    <div>There are no results</div>
                    :
                    tutor.map(item =>
                        <>
                        <tr>
                            <td width="200">ID</td>
                            <td width="10">:</td>
                            <td>{item.idtutor}</td>
                        </tr>

                        <tr>
                            <td width="200">Tipo</td>
                            <td width="10">:</td>
                            <td>{item.tipo}</td>
                        </tr>

                        <tr>
                            <td width="200">Apellido Paterno</td>
                            <td width="10">:</td>
                            <td>{item.apellidopaterno}</td>
                        </tr>

                        <tr>
                            <td width="200">Apellido Materno</td>
                            <td width="10">:</td>
                            <td>{item.apellidomaterno}</td>
                        </tr>

                        <tr>
                            <td width="200">Nombres</td>
                            <td width="10">:</td>
                            <td>{item.nombres}</td>
                        </tr>

                        <tr>
                            <td width="200">Ocupación</td>
                            <td width="10">:</td>
                            <td>{item.ocupacion}</td>
                        </tr>

                        <tr>
                            <td width="200">Trabaja En</td>
                            <td width="10">:</td>
                            <td>{item.trabajaen}</td>
                        </tr>

                        <tr>
                            <td width="200">Teléfono</td>
                            <td width="10">:</td>
                            <td>{item.telefono}</td>
                        </tr>

                        <tr>
                            <td width="200">Correo</td>
                            <td width="10">:</td>
                            <td>{item.correo}</td>
                        </tr>

                        <tr>
                            <td width="200">Número Hijos</td>
                            <td width="10">:</td>
                            <td>{item.numerohijos}</td>
                        </tr>


                        </>
                        )
                }

            </tbody>
        </Table>

    );
};

export default connect(mapStateToProps, null)(TutorDetail);
